/**
 * The landing FAQ id list.
 *
 * Single source of truth: <FAQSection> renders these and <StructuredData>
 * emits the same ids as `FAQPage` entities. Two copies of this array drift,
 * and a drifted copy publishes a rich result the page does not actually show.
 */
export const FAQ_ITEMS = [
  "free",
  "byok",
  "mobileApp",
  "medical",
  "protocols",
  "privacy",
  "languages",
  "featureBreadth",
  "selfHosting",
] as const;

export type FaqItemId = (typeof FAQ_ITEMS)[number];
